import React from "react";

import HTMLReactParser from "html-react-parser";

import AnswerCard from "./AnswerCard";

import "./Quiz.scss";

export default function Quiz(props) {
  const { handleAnswerClick, question, selectedAnswer } = props;

  const renderAnswers = () => {
    let answersIndex = ["A", "B", "C", "D"];

    return answersIndex.map((indexString, index) => {
      if (selectedAnswer && question.answer === index + 1) {
        return <AnswerCard key={index} index={index} isAnswered={selectedAnswer ? true : false} answerTitle={question[`option${indexString}`]} indexString={indexString} handleAnswerClick={handleAnswerClick} correct />;
      } else if (selectedAnswer && selectedAnswer.selected === index + 1 && !selectedAnswer.flag) {
        return <AnswerCard key={index} index={index} isAnswered={selectedAnswer ? true : false} answerTitle={question[`option${indexString}`]} indexString={indexString} handleAnswerClick={handleAnswerClick} incorrect />;
      }
      return <AnswerCard key={index} index={index} isAnswered={selectedAnswer ? true : false} answerTitle={question[`option${indexString}`]} indexString={indexString} handleAnswerClick={handleAnswerClick} />;
    });
  };

  return (
    <div className="quiz_card">
      <div className="quiz_question" style={{ animationName: selectedAnswer ? "animateHeight" : "" }}>
        {question?.question}
      </div>
      <div className="quiz_answer_container">{renderAnswers()}</div>
      {selectedAnswer && (
        <div className="quiz_answer_description">
          <h3>Solution</h3>
          {HTMLReactParser(question.description)}
        </div>
      )}
    </div>
  );
}
